import WorkspaceAPI from '../WorkspaceAPI';

function useCommanderIdsByWorkspace(workspaceId: string) {
  const { data, isLoading, error } =
    WorkspaceAPI.useGetWorkspaceUsageQuery(workspaceId);

  return {
    commanders: data?.commanders ?? [],
    isLoading,
    error,
  };
}

export default useCommanderIdsByWorkspace;
